import type { ReactNode } from "react";
import SacristyLogo from "./SacristyLogo";

// Consistent header for every auth screen and every sub-state within
// them (sign-in, signup, password reset, and their result screens —
// "Check your email", "Link expired", "Password updated", etc.).
//
// The point is that the brand mark is PERSISTENT: it sits above the
// title on every state, including the result screens, which previously
// dropped it entirely (a password-changed confirmation with no brand
// reads like a system error page, not "your parish's app"). The title
// is a separate contextual <h1> so each screen actually says what it
// is, rather than leaning on the lede to carry that.
//
// `brand` defaults to the Sacristy wordmark (admin surfaces, which are
// always Sacristy-branded regardless of parish). Volunteer surfaces
// pass <VolunteerBrandMark/> so the parish's own uploaded logo shows
// when set, falling back to the same wordmark when not.
export default function AuthScreenHeader({
  brand,
  title,
  subtitle,
}: {
  brand?: ReactNode;
  title: string;
  subtitle?: ReactNode;
}) {
  return (
    <div className="sign-in__head">
      <div className="sign-in__brand">{brand ?? <SacristyLogo />}</div>
      <h1 className="sign-in__title">{title}</h1>
      {subtitle ? <p className="sign-in__lede">{subtitle}</p> : null}
    </div>
  );
}
